import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import ThemeSelector from './Component/Themes/ThemeSelector';

import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

import { ServiceContainer } from './Service/ServiceContainer/ServiceContainer';

const { storeConfigurator, storeGateway } = ServiceContainer;
const { store, persistor } = storeConfigurator.initializeStore();
storeGateway.setStore(store);

const root = createRoot(document.getElementById("root") as HTMLElement);

root.render(
    <React.StrictMode>
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <ThemeSelector>
                    <App />
                </ThemeSelector>
            </PersistGate>
        </Provider>
    </React.StrictMode>
);
